module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown",
    class: {
      'dropdown_margin': _vm.externalControl
    }
  }, [(!_vm.externalControl) ? _c('div', {
    staticClass: "dropdown__header",
    class: {
      'dropdown__header_alwaysopen': _vm.alwaysOpen
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('h2', {
    staticClass: "dropdown__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('h3', {
    staticClass: "dropdown__desc"
  }, [_vm._v(_vm._s(_vm.description))]), (!_vm.noArrow) ? _c('div', {
    staticClass: "dropdown__arrow",
    class: {
      'dropdown__arrow_opened': _vm.dropdownOpened
    }
  }) : _vm._e()]) : _vm._e(), _c('Accordion', {
    staticClass: "dropdown__content",
    class: {
      'dropdown__content_opened': _vm.dropdownOpened
    },
    attrs: {
      "opened": _vm.dropdownOpened,
      "height": _vm.height
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a83bee4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/dropdown/Dropdown.vue
// module id = e0f7df4574be3d82ddf2
// module chunks = 89